export { WindDetails } from './wind-details.page';
